export default __webpack_public_path__ + "static/media/AlertIcon.dc4b2041.svg";